export enum QuestionAnswerPairType {

    ORTHODONTIA_QUESTION = "orthodontia_questions",
    DENTISTRY_QUESTION = "dentistry_questions"

}